import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=4738bf1e&scoped=true"
import script from "./Instagram.vue?vue&type=script&lang=js"
export * from "./Instagram.vue?vue&type=script&lang=js"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=4738bf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738bf1e",
  null
  
)

export default component.exports